module.exports = __webpack_public_path__ + "static/media/shambling-mound.b5d93f2e.svg";